import { useModel as _useModel, mergeModels as _mergeModels } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "page-progress",
  role: "group",
  "aria-label": "Seiten"
}
const _hoisted_2 = ["aria-label", "aria-current", "onClick"]
const _hoisted_3 = { class: "segment-track" }

import { computed } from 'vue';


export default {
  __name: 'PageProgress',
  props: /*@__PURE__*/_mergeModels({
  count: {
    type: Number,
    required: true,
  },
  durationMs: {
    type: Number,
    default: 5000,
  },
  paused: {
    type: Boolean,
    default: false,
  },
}, {
    "modelValue": {
  type: Number,
  required: true,
},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

const props = __props;

const page = _useModel(__props, "modelValue");

const indices = computed(() => Array.from({ length: props.count }, (_, index) => index));
const fillStyle = computed(() => ({ animationDuration: `${props.durationMs}ms` }));

const advance = () => {
  page.value = (page.value + 1) % props.count;
};

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(indices.value, (index) => {
      return (_openBlock(), _createElementBlock("button", {
        key: index,
        type: "button",
        class: _normalizeClass(["segment", { 'is-done': index < page.value }]),
        "aria-label": `Seite ${index + 1} von ${__props.count}`,
        "aria-current": index === page.value ? 'true' : undefined,
        onClick: $event => (page.value = index)
      }, [
        _createElementVNode("span", _hoisted_3, [
          _createCommentVNode(" The fill's animationend drives the page change, so bar and content never drift apart "),
          (index === page.value)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["segment-fill", { 'is-paused': __props.paused }]),
                style: _normalizeStyle(fillStyle.value),
                onAnimationend: advance
              }, null, 38 /* CLASS, STYLE, NEED_HYDRATION */))
            : _createCommentVNode("v-if", true)
        ])
      ], 10 /* CLASS, PROPS */, _hoisted_2))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

}